module.exports = __webpack_public_path__ + "static/media/Artboard15.dbab69b2.png";